import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { DeliveryEstimateComponent } from '../delivery-estimate/delivery-estimate.component';
import { AddressSearchFieldComponent } from '../../../general/address-search-field/address-search-field.component';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'app-delivery-estimate-dialog',
    templateUrl: './delivery-estimate-dialog.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, AddressSearchFieldComponent, ReactiveFormsModule, DeliveryEstimateComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class DeliveryEstimateDialogComponent {
  address = new FormControl();
}
